

















































































































































































































































































































































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import DataSoap from "@/services/DataSoap";
// import CardSnackBar from "@/components/modal/CardSnackBar.vue";
import { storeSoap } from "@/store/modules/soap";
import http from "@/axios/http-common";
import ComponentTanggal from "../components/Tanggal.vue";
import { isEmpty, isNull } from "lodash";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import DataObject from "@/utility/DataObject";
import moment from "moment";
import { storeCopy } from "@/store/modules/copy";
import GenerateSoap from "@/components/pemeriksaan/soap/GenerateSoap.vue";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import TandaVital from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/TandaVital.vue";
import Antropometri from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/Antropometri.vue";
import Nyeri from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/Nyeri.vue";
import { storePemeriksaanFisikRalan } from "@/store/modules/pemeriksaanfisikralan";
import DataPemeriksaanFisikRalan from "@/services/DataPemeriksaanFisikRalan";
import PemeriksaanFisik from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/PemeriksaanFisik.vue";
import ModalBatalSoap from "@/components/modal/ModalBatalSoap.vue";
import InputDiagnosisICD from "@/components/InputDiagnosisICD.vue";
import storeBilling from "@/store/modules/Billing";
import RekamAsuhanHemodialisisSvc from "@/services/RekamAsuhanHemodialisis";
import { soapDariAsuhanHd } from "@/components/pemeriksaan/tabs/rekam-medis/rekam-asuhan-hemodialisis/soapDariAsuhanHd";
import { isHemodialisa } from "@/utils/unit";

interface SalinanCppt {
  subjective?: string | null;
  objective?: string | null;
  assesment?: string | null;
  plan?: string | null;
  instruksi?: string | null;
}

@Component({
  components: {
    GenerateSoap,
    // CardSnackBar,
    TandaVital,
    Antropometri,
    Nyeri,
    PemeriksaanFisik,
    ModalBatalSoap,
    InputDiagnosisICD
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardCatatanSOAP extends Vue {
  @Prop() register!: string;
  // @Prop() readonly sess_login!: object;
  // @Prop() dataSoap!: object;
  @Prop() copySoap!: object;
  @Prop({ default: null }) salinan!: SalinanCppt | null;
  @Prop() rm!: string;
  @Prop() disableInput!: boolean;
  @Ref() readonly sub;
  @Ref() examinedAtPicker: HTMLElement;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  sess_login = userModule.user;
  btn = "hidden";
  memuatAsuhanHd = false;
  // s = "";
  // o = "";
  // a = "";
  // p = "";
  alert = "";
  // idSoap = "";
  // textSnackBar = "";
  // showSnackBar = false;
  btnUbah = false;
  btnSimpan = false;
  disable = false;
  menu2 = false;
  tglShow = false;
  // overlay = false;
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  time = new Date()
    .toLocaleString("en-CA", { hour12: false, timeZone: "Asia/Jakarta" })
    .toString()
    .substr(12, 5); //perlu di set format time ke hh:mm    hour: '2-digit'
  today = new Date().toISOString().substr(0, 10);
  minDate = new Date().toISOString().substr(0, 10); // min date
  tglIsi = new Date().toISOString().substr(0, 10);
  soapperawat = {};
  generate = false;
  // showRadioNyeri = false;
  transfer = false;

  // pemeriksaan_fisik = {
  tanda_vital = {
    sistole: "",
    diastole: "",
    frekuensi_nadi: "",
    frekuensi_nafas: "",
    suhu_badan: "",
    saturasi_oksigen: "",
    keadaan_umum: "",
    kesadaran: ""
  };
  antropometri = {
    berat_badan: "",
    tinggi_badan: "",
    imt: "",
    lingkar_kepala: "",
    lla: ""
  };
  nyeri = {
    skala: 0,
    lokasi: "",
    durasi: "",
    frekuensi: "",
    pencetus: "",
    kualitas: "",
    pola_serangan: "",
    penyebab_hilang: "",
    jenis: "0"
  };
  getparam = {
    unit_id: this.sess_login.unit_id,
    reg: this.register
  };
  // };
  loadingSimpan = false;
  showbatal = false;
  loadingHapus = false;
  saving = false;
  showInputDxModal = false;
  savingDiag = false;
  saveDiag = false;

  get tglIsiFormattedMomentjs() {
    return this.tglIsi ? moment(this.tglIsi).format("DD MMMM YYYY") : "";
  }

  get stateuser() {
    return userModule.user;
  }

  get isUnitHemodialisa(): boolean {
    return [this.stateuser.unit_id, this.stateuser.unit_group_id].some(kode => isHemodialisa(kode));
  }

  async generateDariAsuhanHd() {
    if (this.memuatAsuhanHd) return;

    const register = this.register;
    this.memuatAsuhanHd = true;
    let hasil;
    try {
      const [katalog, perRegister] = await Promise.all([
        RekamAsuhanHemodialisisSvc.katalog(),
        RekamAsuhanHemodialisisSvc.getByRegister(register, this.rm)
      ]);
      hasil = {
        katalog,
        doc: perRegister.data.find(it => String(it.register_id) === String(register)) || null
      };
    } catch (err) {
      return;
    } finally {
      this.memuatAsuhanHd = false;
    }
    if (register !== this.register || !this.canMakeSoap) return;

    if (!hasil.doc) {
      appModule.sendErrorAlert("Belum ada Rekam Asuhan Hemodialisis untuk kunjungan ini. Isi formulirnya di tab Rekam Asuhan Hemodialisis terlebih dahulu.");
      return;
    }

    const ctt = this.statesoapdata;
    const adaIsian = [ctt.s, ctt.o, ctt.a, ctt.p].some(v => v && String(v).trim() !== "");
    if (adaIsian && !confirm("Isian SOAP yang sekarang akan ditimpa hasil generate dari Asesmen HD. Lanjutkan?")) return;

    const soap = soapDariAsuhanHd(hasil.doc, hasil.katalog);
    ctt.s = soap.s;
    ctt.o = soap.o;
    ctt.a = soap.a;
    ctt.p = soap.p;
    appModule.sendSuccessNotice(
      `SOAP diisi dari Rekam Asuhan Hemodialisis sesi ${moment(hasil.doc.waktu_hd, "YYYY-MM-DD HH:mm").format("DD-MM-YYYY HH:mm")}. Periksa & sesuaikan sebelum disimpan.`
    );
  }

  get diags() {
    return storeBilling.diagnosis;
  }

  get diagList() {
    return this.diags?.diagnosis ?? [];
  }

  changeDate(date: string) {
    this.today = date;
  }

  @Watch("salinan")
  onSalinan(val: SalinanCppt | null) {
    if (!val || !this.statesoapdata) return;

    const peta = {
      s: val.subjective,
      o: val.objective,
      a: val.assesment,
      p: val.plan,
      instruksi: val.instruksi
    };

    const adaIsi = ["s", "o", "a", "p", "instruksi"].some(
      kunci => !!this.statesoapdata[kunci]
    );

    if (adaIsi) {
      const lanjut = window.confirm(
        "Catatan SOAP ini sudah terisi. Menyalin akan menimpa isinya. Lanjutkan?"
      );
      if (!lanjut) return;
    }

    Object.keys(peta).forEach(kunci => {
      this.statesoapdata[kunci] = peta[kunci] || null;
    });
  }

  @Watch("copySoap")
  ss() {
    // console.log("jhskjashdjkahskjd");
  }

  mounted() {
    const minn = new Date(new Date().setDate(new Date().getDate() - 3));
    this.minDate = minn.toISOString().substring(0, 10);
    // console.log(this.copySoap)
    // this.getSOAP()
    // console.log('m ',this.dataSoap)
    // console.log("ss", this.dataSoap);
    // console.log("stateAsesmenAwal", this.stateAsesmenAwal);
    this.generate = false;
    const getparam = {
      unit_id: this.stateuser.unit_id,
      reg: this.register
    };
    storePemeriksaanFisikRalan.actPemeriksaanFisikRalan(getparam);
    this.$nextTick(() => {
      this.sub.focus();
    });
  }

  @Watch("register")
  change(val, oldval) {
    this.register = val;
    // console.log('aa ',this.register)
  }

  stateSoap() {
    storeSoap.act_soap_on_reg(this.register);
    // storeSoap.act_on_reg(this.register, this.sess_login["user"].id);
    this.$emit("tersimpan");
  }
  get statusPaste() {
    // this.getSOAP(storeSoap.soap);
    return storeCopy.copySoap;
  }

  get statusPasteInstant() {
    return storeCopy.copySoapInstant;
  }

  get soapInstantSave() {
    return storeCopy.soapInstantSave;
  }

  get paste() {
    return storeCopy.pastesoap;
  }
  get statesoapdata() {
    // this.getSOAP(storeSoap.soap);
    return storeSoap.ctt;
  }

  get canMakeSoap() {
    if (this.readOnly) return false;
    return this.statesoapdata.id == null;
  }

  get canEditSoap() {
    if (this.readOnly) return false;
    return this.statesoapdata.id !== null;
  }

  get formatedExaminedAt() {
    return this.examinedAt
      ? moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss")
      : null;
  }

  @Watch("formatedExaminedAt")
  changedExaminedAt(val) {
    if (!val) {
      this.examinedAtPicker["clearHandler"]();
    }
  }

  @Watch("statusPasteInstant")
  changeStatusPasteInstant(val) {
    if (val) {
      this.tempelSoapInstant(this.paste);
    }
  }

  @Watch("soapInstantSave")
  changeSoapInstantSave(val) {
    if (val) {
      this.SimpanSoap();
    }
  }

  setSOAP() {
    // console.log(this.statesoapdata.id);
    // const data = this.statesoapdata["data"];
    // console.log("w ", data);
    if (this.statesoapdata.id == null) {
      this.disable = false;
      this.btnUbah = false;
      this.btnSimpan = true;
      // console.log('kosong')
    } else {
      // const dta = data[0];
      // this.tglIsi = data[0].writed_at.substr(0, 10);
      // this.time = data[0].writed_at.substr(11, 5);
      this.disable = true;
      this.btnUbah = true;
      this.btnSimpan = false;
    }
  }

  SimpanSoap() {
    if (!this.saving) {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        appModule.setLoading(true);
        this.saving = true;

        const datetime = this.tglIsi + " " + this.time + ":00";
        // let dt: object = {}
        if (this.sess_login["profesi"] == "Dokter") {
          const dt = DataSoap.saveDataSoapDokter(
            this.register,
            this.rm,
            this.sess_login["id"],
            this.sess_login["unit_id"],
            this.statesoapdata.s,
            this.statesoapdata.o,
            this.statesoapdata.a,
            this.statesoapdata.p,
            this.statesoapdata.instruksi,
            this.formatedExaminedAt
          );
          dt.then(dt => {
            // this.overlay = !this.overlay;
            if (dt?.["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
              // this.stateSoap();
            } else {
              appModule.NoticeDelay("Berhasil Simpan SOAP");
              // this.textSnackBar = "Berhasil Simpan SOAP";
              // this.tampilSnackBar();
              // this.$emit("reload", "1");
              // this.btnUbah = true;
              // this.btnSimpan = false;
              // this.disable = true;
              this.stateSoap();
              // this.getSOAP()
            }
          }).finally(() => {
            appModule.setLoading(false);
            this.saving = false;
          });
        } else {
          const dt = DataSoap.saveDataSoapPerawat(
            this.register,
            this.rm,
            this.sess_login["id"],
            this.sess_login["unit_id"],
            this.statesoapdata.s,
            this.statesoapdata.o,
            this.statesoapdata.a,
            this.statesoapdata.p,
            this.statesoapdata.instruksi,
            this.formatedExaminedAt
          );
          dt.then(dt => {
            // this.overlay = !this.overlay;
            if (dt?.["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
              // this.stateSoap();
            } else {
              appModule.NoticeDelay("Berhasil Simpan SOAP");
              // this.textSnackBar = "Berhasil Simpan SOAP";
              // this.tampilSnackBar();
              // this.btnUbah = true;
              // this.btnSimpan = false;
              // this.disable = true;
              this.stateSoap();
              // this.getSOAP()
            }
          }).finally(() => {
            appModule.setLoading(false);
            this.saving = false;

            storeCopy.clear_copy_soap();
          });
        }
      }
    }
  }

  UbahSoap() {
    if (!this.saving) {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        appModule.setLoading(true);
        this.saving = true;

        if (this.sess_login["profesi"] == "Dokter") {
          const dt = DataSoap.changeDataSoapDokter(
            this.statesoapdata.s,
            this.statesoapdata.o,
            this.statesoapdata.a,
            this.statesoapdata.p,
            this.statesoapdata.instruksi,
            this.formatedExaminedAt,
            this.statesoapdata.id
          );
          dt.then(dt => {
            appModule.setLoading(false);

            if (dt?.["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
              // this.stateSoap();
            } else {
              appModule.NoticeDelay("Berhasil Ubah SOAP");

              this.stateSoap();
            }
          }).finally(() => {
            appModule.setLoading(false);
            this.saving = false;
          });
        } else {
          const dt = DataSoap.changeDataSoapPerawat(
            this.statesoapdata.s,
            this.statesoapdata.o,
            this.statesoapdata.a,
            this.statesoapdata.p,
            this.statesoapdata.instruksi,
            this.formatedExaminedAt,
            this.statesoapdata.id
          );
          dt.then(dt => {
            appModule.setLoading(false);
            // this.overlay = !this.overlay;
            if (dt?.["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
              // this.stateSoap();
            } else {
              appModule.NoticeDelay("Berhasil Ubah SOAP");

              this.stateSoap();
            }
          }).finally(() => {
            appModule.setLoading(false);
            this.saving = false;
          });
        }
      }
    }
  }

  tempelSoap(val) {
    console.log("tempelSoap");
    if (
      !this.statesoapdata.s ||
      !this.statesoapdata.o ||
      !this.statesoapdata.a ||
      !this.statesoapdata.p
    ) {
      this.statesoapdata.s = val["s"];
      this.statesoapdata.o = val["o"];
      this.statesoapdata.a = val["a"];
      this.statesoapdata.p = val["p"];

      storeCopy.clear_copy_soap();
    } else {
      this.alert = "Sudah ada SOAP tersedia, tidak bisa menimpa.";
      appModule.sendErrorAlert(this.alert);
    }
  }

  tempelSoapInstant(val) {
    console.log("tempelSoapInstant");
    if (
      !this.statesoapdata.s ||
      !this.statesoapdata.a ||
      !this.statesoapdata.p
    ) {
      this.statesoapdata.s = val["s"];
      // this.statesoapdata.o = val["o"];
      this.statesoapdata.a = val["a"];
      this.statesoapdata.p = val["p"];

      storeCopy.clear_copy_soap();
    } else {
      this.alert = "Sudah ada SOAP tersedia, tidak bisa menimpa.";
      appModule.sendErrorAlert(this.alert);
    }
  }

  generateSoap(kode) {
    console.log("generateSoap", kode);
    if (kode == "S") {
      // console.log(this.stateAnemnesis);
      const anamnesis = this.gabungSubjective();
      this.copyGenerate(anamnesis, kode);
    } else if (kode == "O") {
      const obj = this.gabungObjective();
      this.copyGenerate(obj, kode);
    } else if (kode == "A") {
      const ass = this.gabungAssesment();
      this.copyGenerate(ass, kode);
      // this.copyGenerate(this.stateDiagnosis.diagnosis, kode);
    } else if (kode == "P") {
      const plan = this.gabungPlan();
      this.copyGenerate(plan, kode);
      // this.copyGenerate(this.stateRencana.rencana, kode);
    }
  }

  gabungSubjective() {
    let subj = "";
    if (this.stateAsesmenAwal != undefined) {
      if (this.stateuser.profesi == "Dokter") {
        // let subj = "";
        if (this.stateAsesmenAwal["keluhan_utama_medis"]) {
          subj =
            subj +
            // "Keluhan Utama: " +
            this.stateAsesmenAwal["keluhan_utama_medis"];
          subj = subj + "\n";
        }
        if (this.stateAsesmenAwal["riwayat_penyakit_sekarang"]) {
          subj =
            subj +
            // "Riwayat Penyakit Sekarang: " +
            this.stateAsesmenAwal["riwayat_penyakit_sekarang"];
          subj = subj + "\n";
        }
        return subj;
      } else {
        let subj = "";
        if (this.stateAsesmenAwal["anamnesis"].keluhan) {
          subj =
            subj + "Keluhan: " + this.stateAsesmenAwal["anamnesis"].keluhan;
          subj = subj + "\n";
        }
        if (this.stateAsesmenAwal["riwayat_perawatan_sebelum"]) {
          subj =
            subj +
            "Riwayat perawatan sebelumnya: " +
            this.stateAsesmenAwal["riwayat_perawatan_sebelum"];
          subj = subj + "\n";
        }
        if (this.stateAsesmenAwal["anamnesis"].status_psikologis_id != "0") {
          if (this.stateAsesmenAwal["anamnesis"].status_psikologis_id == "1") {
            subj = subj + "Status Psikologi: Cemas Ringan";
          } else if (
            this.stateAsesmenAwal["anamnesis"].status_psikologis_id == "2"
          ) {
            subj = subj + "Status Psikologi: Cemas Sedang";
          } else if (
            this.stateAsesmenAwal["anamnesis"].status_psikologis_id == "3"
          ) {
            subj = subj + "Status Psikologi: Cemas Berat";
          } else if (
            this.stateAsesmenAwal["anamnesis"].status_psikologis_id == "9"
          ) {
            subj =
              subj +
              "Status Psikologi: Lainnya, " +
              this.stateAsesmenAwal["anamnesis"].status_psikologis_text;
          }
        }
        return subj;
      }
    }
    // else {
    //   if (this.stateAnemnesis.keluhan) {
    //     subj = subj + "Keluhan : " + this.stateAnemnesis.keluhan;
    //     subj = subj + "\n";
    //   }
    //   if (this.stateAnemnesis["mualmuntah"][0]) {
    //     if (this.stateAnemnesis["mualmuntah"][0].mual == 0) {
    //       subj = subj + "Mual : Tidak";
    //       subj = subj + "\n";
    //     } else {
    //       subj = subj + "Mual : Ya";
    //       subj = subj + "\n";
    //     }
    //     if (this.stateAnemnesis["mualmuntah"][0].muntah == 0) {
    //       subj = subj + "Muntah : Tidak";
    //       subj = subj + "\n";
    //     } else {
    //       subj = subj + "Muntah : Ya";
    //       subj = subj + "\n";
    //     }
    //   }
    //   if (this.stateAnemnesis.riwayat_penyakit) {
    //     subj =
    //       subj + "Riwayat Penyakit : " + this.stateAnemnesis.riwayat_penyakit;
    //     subj = subj + "\n";
    //   }
    //   if (this.stateAnemnesis.status_psikologis_id != "0") {
    //     if (this.stateAnemnesis.status_psikologis_id == "1") {
    //       subj = subj + "Status Psikologi : Cemas Ringan";
    //     } else if (this.stateAnemnesis.status_psikologis_id == "2") {
    //       subj = subj + "Status Psikologi : Cemas Sedang";
    //     } else if (this.stateAnemnesis.status_psikologis_id == "3") {
    //       subj = subj + "Status Psikologi : Cemas Berat";
    //     } else if (this.stateAnemnesis.status_psikologis_id == "9") {
    //       subj =
    //         subj +
    //         "Status Psikologi : Lainnya, " +
    //         this.stateAnemnesis.status_psikologis_text;
    //     }
    //   }
    //   return subj;
    // }
  }
  gabungObjective() {
    let obj = "";
    const degree = "o";
    // console.log(this.stateTandaVital.sistole);
    if (this.stateAsesmenAwal != undefined) {
      if (this.stateAsesmenAwal["tanda_vital"]) {
        if (
          this.stateAsesmenAwal["tanda_vital"].sistole &&
          this.stateAsesmenAwal["tanda_vital"].diastole
        )
          obj =
            obj +
            "TD: " +
            this.stateAsesmenAwal["tanda_vital"].sistole +
            "/" +
            this.stateAsesmenAwal["tanda_vital"].diastole +
            " mmHg";
        if (this.stateAsesmenAwal["tanda_vital"].frekuensi_nadi)
          obj =
            obj +
            ", Nadi: " +
            this.stateAsesmenAwal["tanda_vital"].frekuensi_nadi +
            " x/menit";
        if (this.stateAsesmenAwal["tanda_vital"].frekuensi_nafas)
          obj =
            obj +
            ", Nafas: " +
            this.stateAsesmenAwal["tanda_vital"].frekuensi_nafas +
            " x/menit";
        if (this.stateAsesmenAwal["tanda_vital"].suhu_badan)
          obj =
            obj +
            ", SB: " +
            this.stateAsesmenAwal["tanda_vital"].suhu_badan +
            " \u2070C";
        if (this.stateAsesmenAwal["tanda_vital"].saturasi_oksigen)
          obj =
            obj +
            ", SpO2: " +
            this.stateAsesmenAwal["tanda_vital"].saturasi_oksigen +
            "%";
        if (this.stateAsesmenAwal["tanda_vital"].keadaan_umum)
          obj =
            obj + ", KU: " + this.stateAsesmenAwal["tanda_vital"].keadaan_umum;
        if (this.stateAsesmenAwal["tanda_vital"].kesadaran)
          obj =
            obj +
            ", Kesadaran: " +
            this.stateAsesmenAwal["tanda_vital"].kesadaran;
        obj = obj + ";\n";
      }

      if (this.stateAsesmenAwal["antropometri"]) {
        // obj = obj + "\n";
        if (this.stateAsesmenAwal["antropometri"].berat_badan)
          obj =
            obj +
            "BB: " +
            this.stateAsesmenAwal["antropometri"].berat_badan +
            " kg";
        if (this.stateAsesmenAwal["antropometri"].tinggi_badan)
          obj =
            obj +
            ", TB: " +
            this.stateAsesmenAwal["antropometri"].tinggi_badan +
            " cm";
        if (
          this.stateAsesmenAwal["antropometri"].berat_badan &&
          this.stateAsesmenAwal["antropometri"].tinggi_badan
        )
          obj =
            obj +
            ", IMT: " +
            this.setImt(
              this.stateAsesmenAwal["antropometri"].berat_badan,
              this.stateAsesmenAwal["antropometri"].tinggi_badan
            );
        if (this.stateAsesmenAwal["antropometri"].lingkar_kepala)
          obj =
            obj +
            ", Lingkar Kepala: " +
            this.stateAsesmenAwal["antropometri"].lingkar_kepala +
            " cm";
        if (this.stateAsesmenAwal["antropometri"].lla)
          obj =
            obj + ", LLA: " + this.stateAsesmenAwal["antropometri"].lla + " cm";

        obj = obj + ";\n";
      }

      if (this.stateAsesmenAwal["fungsional"]) {
        // obj = obj + "\n";
        if (this.stateAsesmenAwal["fungsional"].alat_bantu)
          obj =
            obj +
            "Alat Bantu: " +
            this.stateAsesmenAwal["fungsional"].alat_bantu;
        if (this.stateAsesmenAwal["fungsional"].prothesa)
          obj =
            obj + ", Prothesa: " + this.stateAsesmenAwal["fungsional"].prothesa;
        if (this.stateAsesmenAwal["fungsional"].cacat_tubuh)
          obj =
            obj +
            ", Cacat Tubuh: " +
            this.stateAsesmenAwal["fungsional"].cacat_tubuh;
        if (this.stateAsesmenAwal["fungsional"].adl) {
          if (this.stateAsesmenAwal["fungsional"].adl == "0")
            obj = obj + ", ADL: Mandiri";
          else obj = obj + ", ADL: Dibantu";
        }

        obj = obj + ";\n";
      }

      if (this.stateAsesmenAwal["nyeri"]) {
        if (this.stateAsesmenAwal["nyeri"].skala) {
          // obj = obj + "\n";
          // if (this.stateAsesmenAwal["nyeri"].skala == 0)
          //   obj = obj + "Skala Nyeri: Tidak Nyeri";
          // else if (this.stateAsesmenAwal["nyeri"].skala < 4)
          //   obj = obj + "Skala Nyeri: Nyeri Ringan";
          // else if (this.stateAsesmenAwal["nyeri"].skala < 7)
          //   obj = obj + "Skala Nyeri: Nyeri Sedang";
          // else obj = obj + "Skala Nyeri: Nyeri Berat";
          obj =
            obj +
            "Skala Nyeri: " +
            this.statePemeriksaanFisikRalan.nyeri["skala"];

          if (this.stateAsesmenAwal["nyeri"].lokasi)
            obj = obj + ", Lokasi: " + this.stateAsesmenAwal["nyeri"].lokasi;
          if (this.stateAsesmenAwal["nyeri"].intensitas)
            obj =
              obj +
              ", Intensitas: " +
              this.stateAsesmenAwal["nyeri"].intensitas;
          if (this.stateAsesmenAwal["nyeri"].durasi)
            obj =
              obj +
              ", Durasi: " +
              this.stateAsesmenAwal["nyeri"].durasi +
              " detik";
          if (this.stateAsesmenAwal["nyeri"].frekuensi)
            obj =
              obj +
              ", Frekuensi: " +
              this.stateAsesmenAwal["nyeri"].frekuensi +
              " x/menit";
          if (this.stateAsesmenAwal["nyeri"].pencetus)
            obj =
              obj + ", Pencetus: " + this.stateAsesmenAwal["nyeri"].pencetus;
          if (this.stateAsesmenAwal["nyeri"].kualitas)
            obj =
              obj +
              ", Kualitas Nyeri: " +
              this.stateAsesmenAwal["nyeri"].kualitas;
          if (this.stateAsesmenAwal["nyeri"].pola_serangan)
            obj =
              obj +
              ", Pola Serangan: " +
              this.stateAsesmenAwal["nyeri"].pola_serangan;
          if (this.stateAsesmenAwal["nyeri"].penyebab_hilang)
            obj =
              obj +
              ", Penyebab Nyeri Hilang: " +
              this.stateAsesmenAwal["nyeri"].penyebab_hilang;
          if (this.stateAsesmenAwal["nyeri"].jenis) {
            if (this.stateAsesmenAwal["nyeri"].jenis == "1")
              obj = obj + ", Jenis: Akut";
            else obj = obj + ", Jenis: Kronis";
          }
          obj = obj + ";";
        }
        // if (this.stateAsesmenAwal["nyeri"].skala) {
        //   obj = obj + " xxxx";
        // }
      }

      // Free-text fields the doctor types directly on Asesmen Awal Ralan
      // (Status Lokalis findings + Pemeriksaan Penunjang) — without these,
      // OBJECTIVE comes out empty for doctor-only assessments where the
      // nurse hasn't filled vitals/antropometri.
      const statusLokalisCatatan =
        this.stateAsesmenAwal["status_lokalis"] &&
        this.stateAsesmenAwal["status_lokalis"].catatan
          ? String(this.stateAsesmenAwal["status_lokalis"].catatan).trim()
          : "";
      if (statusLokalisCatatan) {
        if (obj && !obj.endsWith("\n")) obj = obj + "\n";
        obj = obj + "Status Lokalis: " + statusLokalisCatatan + ";\n";
      }

      const penunjangText = this.stateAsesmenAwal["penunjang"]
        ? String(this.stateAsesmenAwal["penunjang"]).trim()
        : "";
      if (penunjangText) {
        if (obj && !obj.endsWith("\n")) obj = obj + "\n";
        obj = obj + "Pemeriksaan Penunjang: " + penunjangText + ";";
      }
    } else if (this.statePemeriksaanFisikRalan != undefined) {
      if (this.statePemeriksaanFisikRalan.tanda_vital) {
        if (
          this.statePemeriksaanFisikRalan.tanda_vital["sistole"] &&
          this.statePemeriksaanFisikRalan.tanda_vital["diastole"]
        )
          obj =
            obj +
            "TD: " +
            this.statePemeriksaanFisikRalan.tanda_vital["sistole"] +
            "/" +
            this.statePemeriksaanFisikRalan.tanda_vital["diastole"] +
            " mmHg";
        if (this.statePemeriksaanFisikRalan.tanda_vital["frekuensi_nadi"])
          obj =
            obj +
            ", Nadi: " +
            this.statePemeriksaanFisikRalan.tanda_vital["frekuensi_nadi"] +
            " x/menit";
        if (this.statePemeriksaanFisikRalan.tanda_vital["frekuensi_nafas"])
          obj =
            obj +
            ", Nafas: " +
            this.statePemeriksaanFisikRalan.tanda_vital["frekuensi_nafas"] +
            " x/menit";
        if (this.statePemeriksaanFisikRalan.tanda_vital["suhu_badan"])
          obj =
            obj +
            ", SB: " +
            this.statePemeriksaanFisikRalan.tanda_vital["suhu_badan"] +
            " \u2070C";
        if (this.statePemeriksaanFisikRalan.tanda_vital["saturasi_oksigen"])
          obj =
            obj +
            ", SpO2: " +
            this.statePemeriksaanFisikRalan.tanda_vital["saturasi_oksigen"] +
            "%";
        if (this.statePemeriksaanFisikRalan.tanda_vital["keadaan_umum"])
          obj =
            obj +
            ", KU: " +
            this.statePemeriksaanFisikRalan.tanda_vital["keadaan_umum"];
        if (this.statePemeriksaanFisikRalan.tanda_vital["kesadaran"])
          obj =
            obj +
            ", Kesadaran: " +
            this.statePemeriksaanFisikRalan.tanda_vital["kesadaran"];

        obj = obj + ";\n";
      }
      if (this.statePemeriksaanFisikRalan.antropometri) {
        // obj = obj + "\n";
        if (this.statePemeriksaanFisikRalan.antropometri["berat_badan"])
          obj =
            obj +
            "BB: " +
            this.statePemeriksaanFisikRalan.antropometri["berat_badan"] +
            " kg";
        if (this.statePemeriksaanFisikRalan.antropometri["tinggi_badan"])
          obj =
            obj +
            ", TB: " +
            this.statePemeriksaanFisikRalan.antropometri["tinggi_badan"] +
            " cm";
        if (
          this.stateAsesmenAwal["antropometri"].berat_badan &&
          this.stateAsesmenAwal["antropometri"].tinggi_badan
        )
          obj =
            obj +
            ", IMT: " +
            this.setImt(
              this.stateAsesmenAwal["antropometri"].berat_badan,
              this.stateAsesmenAwal["antropometri"].tinggi_badan
            );
        if (this.statePemeriksaanFisikRalan.antropometri["lingkar_kepala"])
          obj =
            obj +
            ", Lingkar Kepala: " +
            this.statePemeriksaanFisikRalan.antropometri["lingkar_kepala"] +
            " cm";
        if (this.statePemeriksaanFisikRalan.antropometri["lla"])
          obj =
            obj +
            ", LLA: " +
            this.statePemeriksaanFisikRalan.antropometri["lla"] +
            " cm";

        obj = obj + ";\n";
      }
      if (this.statePemeriksaanFisikRalan.nyeri) {
        if (this.statePemeriksaanFisikRalan.nyeri["skala"]) {
          // obj = obj + "\n";
          // if (this.statePemeriksaanFisikRalan.nyeri["skala"] == 0)
          //   obj = obj + "Skala Nyeri: Tidak Nyeri";
          // else if (this.statePemeriksaanFisikRalan.nyeri["skala"] < 4)
          //   obj = obj + "Skala Nyeri: Nyeri Ringan";
          // else if (this.statePemeriksaanFisikRalan.nyeri["skala"] < 7)
          //   obj = obj + "Skala Nyeri: Nyeri Sedang";
          // else obj = obj + "Skala Nyeri: Nyeri Berat";
          obj =
            obj +
            "Skala Nyeri: " +
            this.statePemeriksaanFisikRalan.nyeri["skala"];

          if (this.statePemeriksaanFisikRalan.nyeri["lokasi"])
            obj =
              obj +
              ", Lokasi: " +
              this.statePemeriksaanFisikRalan.nyeri["lokasi"];
          if (this.statePemeriksaanFisikRalan.nyeri["durasi"])
            obj =
              obj +
              ", Durasi: " +
              this.statePemeriksaanFisikRalan.nyeri["durasi"] +
              " detik";
          if (this.statePemeriksaanFisikRalan.nyeri["frekuensi"])
            obj =
              obj +
              ", Frekuensi: " +
              this.statePemeriksaanFisikRalan.nyeri["frekuensi"] +
              " x/menit";
          if (this.statePemeriksaanFisikRalan.nyeri["pencetus"])
            obj =
              obj +
              ", Pencetus: " +
              this.statePemeriksaanFisikRalan.nyeri["pencetus"];
          if (this.statePemeriksaanFisikRalan.nyeri["kualitas"])
            obj =
              obj +
              ", Kualitas Nyeri: " +
              this.statePemeriksaanFisikRalan.nyeri["kualitas"];
          if (this.statePemeriksaanFisikRalan.nyeri["pola_serangan"])
            obj =
              obj +
              ", Pola Serangan: " +
              this.statePemeriksaanFisikRalan.nyeri["pola_serangan"];
          if (this.statePemeriksaanFisikRalan.nyeri["penyebab_hilang"])
            obj =
              obj +
              ", Penyebab Nyeri Hilang: " +
              this.statePemeriksaanFisikRalan.nyeri["penyebab_hilang"];
          if (this.statePemeriksaanFisikRalan.nyeri["jenis"]) {
            if (this.statePemeriksaanFisikRalan.nyeri["jenis"] == "1") {
              obj = obj + ", Jenis: Akut";
            }
            if (this.statePemeriksaanFisikRalan.nyeri["jenis"] == "2") {
              obj = obj + ", Jenis: Kronis";
            } else obj = obj + "";
          }
          obj = obj + ";";
        }
        // if (this.stateAsesmenAwal["nyeri"].skala) {
        //   obj = obj + " xxxx";
        // }
      }
    }
    return obj;
  }

  copyGenerate(value, kode) {
    console.log("copyGenerate");
    if (kode == "S") {
      if (!this.statesoapdata.s) {
        this.statesoapdata.s = value;
      } else {
        appModule.sendErrorAlert(
          "Tidak bisa Generate Subjective karena sudah ada isian Subjective yg anda buat"
        );
      }
    } else if (kode == "O") {
      if (!this.statesoapdata.o) {
        this.statesoapdata.o = value;
      } else {
        appModule.sendErrorAlert(
          "Tidak bisa Generate Objective karena sudah ada isian Objective yg anda buat"
        );
      }
    } else if (kode == "A") {
      if (!this.statesoapdata.a) {
        this.statesoapdata.a = value;
      } else {
        appModule.sendErrorAlert(
          "Tidak bisa Generate Assesment karena sudah ada isian Assesment yg anda buat"
        );
      }
    } else if (kode == "P") {
      if (!this.statesoapdata.p) {
        this.statesoapdata.p = value;
      } else {
        appModule.sendErrorAlert(
          "Tidak bisa Generate Plan karena sudah ada isian Plan yg anda buat"
        );
      }
    }
  }
  gabungAssesment() {
    if (this.stateuser.profesi == "Dokter") {
      if (this.stateAsesmenAwal["diagnosis_medis"]) {
        return this.stateAsesmenAwal["diagnosis_medis"];
      }
    } else {
      if (this.stateAsesmenAwal["diagnosis_perawat"]) {
        return this.stateAsesmenAwal["diagnosis_perawat"];
      }
    }
  }
  gabungPlan() {
    if (this.stateuser.profesi == "Dokter") {
      if (this.stateAsesmenAwal["tindakan_medis"]) {
        return this.stateAsesmenAwal["tindakan_medis"];
      }
    } else {
      if (this.stateAsesmenAwal["tindakan_perawat"]) {
        return this.stateAsesmenAwal["tindakan_perawat"];
      }
    }
  }
  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }
  @Watch("stateAsesmenAwal", { deep: true })
  changestateAsesmenAwal(v, o) {
    if (v) {
      this.generate = true;
    }

    if (this.generate && !this.statesoapdata.id) {
      setTimeout(() => {
        this.generateSoapAll();
      }, 1000);
    }
  }
  generateSoapAll() {
    const subj = this.gabungSubjective();
    this.statesoapdata.s = subj;
    const obj = this.gabungObjective();
    this.statesoapdata.o = obj;
    const ass = this.gabungAssesment();
    this.statesoapdata.a = ass;
    const plan = this.gabungPlan();
    this.statesoapdata.p = plan;

    console.log("generate soap all", subj, obj, ass, plan);
  }
  // get textHeaderTandaVital() {
  //   // console.log("textHeaderTandaVital", this.tanda_vital);
  //   const td =
  //     this.tanda_vital.sistole && this.tanda_vital.diastole
  //       ? "TD: " +
  //         this.tanda_vital.sistole +
  //         "/" +
  //         this.tanda_vital.diastole +
  //         "mmHg"
  //       : "";
  //   const nd = this.tanda_vital.frekuensi_nadi
  //     ? "Nadi: " + this.tanda_vital.frekuensi_nadi + "x/menit"
  //     : "";
  //   const nf = this.tanda_vital.frekuensi_nafas
  //     ? "RR: " + this.tanda_vital.frekuensi_nafas + "x/menit"
  //     : "";
  //   const sb = this.tanda_vital.suhu_badan
  //     ? "SB: " + this.tanda_vital.suhu_badan + "C"
  //     : "";
  //   const o2 = this.tanda_vital.saturasi_oksigen
  //     ? "SpO2: " + this.tanda_vital.saturasi_oksigen + "%"
  //     : "";
  //   const ku = this.tanda_vital.keadaan_umum
  //     ? this.tanda_vital.keadaan_umum
  //     : "";
  //   const kesadaran = this.tanda_vital.kesadaran
  //     ? this.tanda_vital.kesadaran
  //     : "";

  //   return [td, nd, nf, sb, o2, ku, kesadaran].filter(Boolean).join("; ");
  // }

  // get textHeaderAntropometri() {
  //   const bb = this.antropometri.berat_badan
  //     ? "BB: " + this.antropometri.berat_badan + "kg"
  //     : "";
  //   const tb = this.antropometri.tinggi_badan
  //     ? "TB: " + this.antropometri.tinggi_badan + "cm"
  //     : "";
  //   const imt = this.antropometri.imt ? "IMT: " + this.antropometri.imt : "";
  //   const lk = this.antropometri.lingkar_kepala
  //     ? "Lingkar Kepala: " + this.antropometri.lingkar_kepala + "cm"
  //     : "";
  //   const lla = this.antropometri.lla
  //     ? "LLA: " + this.antropometri.lla + "cm"
  //     : "";

  //   return [bb, tb, imt, lk, lla].filter(Boolean).join("; ");
  // }

  // get textHeaderNyeri() {
  //   // console.log("snyeri", this.statePemeriksaanFisikRalan.nyeri);

  //   let skala = "";
  //   if (this.nyeri.skala == "0") {
  //     skala = "Tidak Nyeri";
  //   } else if (this.nyeri.skala < "4") {
  //     skala = "Nyeri Ringan";
  //   } else if (this.nyeri.skala < "7") {
  //     skala = "Nyeri Sedang";
  //   } else {
  //     skala = "Nyeri Berat";
  //   }
  //   let jenis = "";
  //   if (this.nyeri.jenis == "1") {
  //     jenis = "Akut";
  //   } else {
  //     jenis = "Kronis";
  //   }

  //   const sn = this.nyeri.skala
  //     ? "Skala: " + this.nyeri.skala + "(" + skala + ")"
  //     : "";
  //   const lo = this.nyeri.lokasi ? "Lokasi: " + this.nyeri.lokasi : "";
  //   const int = this.nyeri.intensitas
  //     ? "Intensitas: " + this.nyeri.intensitas
  //     : "";
  //   const du = this.nyeri.durasi ? "Durasi: " + this.nyeri.durasi : "";
  //   const fr = this.nyeri.frekuensi ? "Frek.: " + this.nyeri.frekuensi : "";
  //   const pc = this.nyeri.pencetus ? "Pencetus: " + this.nyeri.pencetus : "";

  //   const kn = this.nyeri.kualitas ? "Kualitas: " + this.nyeri.kualitas : "";
  //   const ps = this.nyeri.pola_serangan
  //     ? "Pola Serangan: " + this.nyeri.pola_serangan
  //     : "";
  //   const ph = this.nyeri.penyebab_hilang
  //     ? "Penyebab Hilang: " + this.nyeri.penyebab_hilang
  //     : "";
  //   const jn = this.nyeri.jenis ? "Jenis: " + jenis : "";

  //   return [sn, lo, int, du, fr, pc, kn, ps, ph].filter(Boolean).join("; ");
  // }
  setAntropometri(val) {
    // console.log("setAntropometri ", val);

    this.antropometri = val;
  }
  setNyeri(val) {
    this.nyeri = val;
  }
  // get stateAsesmenAwal() {
  //   return storeAssesmenRalan.asesmenAwal;
  // }

  get statePemeriksaanFisikRalan() {
    return storePemeriksaanFisikRalan.pemeriksaanfisikralan;
  }
  setTandaVital(val) {
    // console.log("setTandaVital", val);
    this.tanda_vital = val;
  }

  @Watch("statePemeriksaanFisikRalan")
  changePemeriksaanFisikRalan(val) {
    if (
      val.tanda_vital == null &&
      val.antropometri == null &&
      val.nyeri == null
    ) {
      this.transfer = false;
    } else {
      this.transfer = true;
    }
    if (val.tanda_vital == null) {
      this.tanda_vital = {
        sistole: "",
        diastole: "",
        frekuensi_nadi: "",
        frekuensi_nafas: "",
        suhu_badan: "",
        saturasi_oksigen: "",
        keadaan_umum: "",
        kesadaran: ""
      };
    } else {
      this.tanda_vital = val.tanda_vital;
    }
    if (val.antropometri == null) {
      this.antropometri = {
        berat_badan: "",
        tinggi_badan: "",
        imt: "",
        lingkar_kepala: "",
        lla: ""
      };
    } else {
      this.antropometri = val.antropometri;
    }
    if (val.nyeri == null) {
      this.nyeri = {
        skala: 0,
        lokasi: "",
        durasi: "",
        frekuensi: "",
        pencetus: "",
        kualitas: "",
        pola_serangan: "",
        penyebab_hilang: "",
        jenis: "0"
      };
    } else {
      this.nyeri = val.nyeri;
    }
  }

  setImt(setBb, setTb) {
    if (setBb < 1 || setTb < 1) {
      return 0;
    } else {
      const v = Number((setBb / Math.pow(setTb / 100, 2)).toFixed(2));
      let keterangan = "";
      if (v < 18.5) {
        keterangan = "(Underweight)";
      } else if (v >= 18.5 && v <= 25.0) {
        keterangan = "(Normal)";
      } else if (v > 25.0 && v < 30) {
        keterangan = "(Overweight)";
      } else if (v > 30) {
        keterangan = "(Obesitas)";
      }
      return v.toFixed(2);
    }
  }

  batalSoap() {
    this.showbatal = true;
  }

  setBatalSoap(v) {
    this.showbatal = false;
    this.loadingHapus = true;
    if (this.stateuser.profesi == "Dokter") {
      const dt = DataSoap.deleteSoapDokter(this.statesoapdata.id, v.alasan);
      dt.then(dt => {
        if (dt?.["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          this.stateSoap();

          appModule.NoticeDelay("Berhasil Hapus Soap");
        }
      })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.loadingHapus = false));
    } else {
      const dt = DataSoap.deleteSoapPerawat(this.statesoapdata.id, v.alasan);
      dt.then(dt => {
        if (dt?.["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          this.stateSoap();

          appModule.NoticeDelay("Berhasil Hapus Soap");
        }
      })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.loadingHapus = false));
    }
  }

  diagSaving(val) {
    this.savingDiag = val;
    this.saveDiag = val;
  }

  @Watch("showInputDxModal")
  changeShowInputDxModal(val) {
    if (!val) {
      this.saveDiag = val;
    }
  }

  showAddDiagIcd = false;

  onFocusAsesmen() {
    console.log("asesmen focused");
    this.showAddDiagIcd = true;
  }

  get isShowDiagPanel() {
    return ["27", "2L"].includes(this.stateuser.unit_id);
  }

  examinedAt = null;

  @Watch("statesoapdata", { deep: true })
  changeStateSoapData(val) {
    if (val) {
      this.examinedAt = val.examined_at
        ? moment(val.examined_at).toDate()
        : moment().toDate();
    }
  }

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };
  dateTimeFieldProps = { outlined: true, dense: true, "hide-details": "auto" };

  datetimeInput() {
    const dtime = new Date();
    if (this.examinedAt > dtime) {
      this.$nextTick(() => {
        this.examinedAt = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat diinput melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }
}
